import React, { useState, useEffect } from "react";

const WarmupClean = () => {
  const [initialRecords, setInitialRecords] = useState(0);
  const [newRecords, setNewRecords] = useState(0);
  const [message, setMessage] = useState("");
  const [intervalId, setIntervalId] = useState(null);
  const [started, setStarted] = useState(false); // New state to track if warmup started

  const fetchWarmupCount = async () => {
    try {
      const res = await fetch("https://utilities.livauto.com/api/warmupcleancount");
      const data = await res.json();
      return data[0]?.records || 0;
    } catch (err) {
      console.error("Error fetching warmup count:", err);
      return 0;
    }
  };

  const startWarmup = async () => {
    try {
      setStarted(true); // Hide button immediately after click

      const initial = await fetchWarmupCount();
      setInitialRecords(initial);

      const res = await fetch("https://utilities.livauto.com/api/warmupclean");
      const data = await res.json();

      if (data.message) {
        setMessage(data.message);

        const id = setInterval(async () => {
          const current = await fetchWarmupCount();
          setNewRecords(current - initial);
        }, 8000);

        setIntervalId(id);
      }
    } catch (err) {
      console.error("Error starting warmup:", err);
      setStarted(false); // Re-show button if error occurs
    }
  };

  useEffect(() => {
    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [intervalId]);

  return (
    <div style={{ padding: "20px", fontFamily: "Arial" }}>
      <h2>Warmup Clean</h2>

      {!started && (
        <button
          onClick={startWarmup}
          style={{
            marginTop: "20px",
            padding: "12px 24px",
            backgroundColor: "#007bff",
            color: "#fff",
            border: "none",
            borderRadius: "6px",
            fontSize: "16px",
            fontWeight: "bold",
            cursor: "pointer",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            transition: "background-color 0.3s, transform 0.2s"
          }}
          onMouseEnter={e => e.currentTarget.style.backgroundColor = "#0056b3"}
          onMouseLeave={e => e.currentTarget.style.backgroundColor = "#007bff"}
          onMouseDown={e => e.currentTarget.style.transform = "scale(0.98)"}
          onMouseUp={e => e.currentTarget.style.transform = "scale(1)"}
        >
          Start Warmup
        </button>
      )}

      {message && <p style={{ marginTop: "10px" }}>{message}</p>}
      {newRecords > 0 && <p>New records processed: {newRecords}</p>}
    </div>
  );
};

export default WarmupClean;
